import { useQuery } from "@tanstack/react-query";
import { reportsSummaryApiService } from "modules/Pharmacy/Reports/api/reportsSummary.api";

export const useReportsSummaryService = () => {
  // SELECT SUBJECT WISE REPORT
  const SelectSubjectWiseQuery = (params: {
    studyid: number | string | null;
    searchtext?: string | null;
    pagesize?: number;
    currentpage?: number;
    status?: string | null;
    subjectno?: string | null;
    ipcategory?: string | null;
    actionname?: string | null;
    fromdate?: string | null;
    todate?: string | null;
    pagination?: boolean;
  }) =>
    useQuery({
      queryKey: ["reports-summary-select-subject-wise", params],
      queryFn: () => reportsSummaryApiService.getSubjectWiseReport(params),
    });

  // SELECT LEDGER REPORT
  const SelectLedgerQuery = (params: {
    studyid?: number | string | null;
    transactiontype?: string | null;
    fromdate?: string | null;
    todate?: string | null;
    searchtext?: string | null;
    status?: string | null;
    currentpage?: number;
    pagesize?: number;
    pagination?: boolean;
    ipcategory?: string | null;
  }) =>
    useQuery({
      queryKey: ["reports-summary-select-ledger", params],
      queryFn: () => reportsSummaryApiService.getLedgerReport(params),
    });

  const SelectIpReportsQuery = ({
    studyid,
    pageNumber = 1,
    pageSize = 10,
    searchText = null,
  }: {
    studyid: number | string | null;
    pageNumber?: number;
    pageSize?: number;
    searchText?: string | null;
  }) =>
    useQuery({
      queryKey: ["ipinventory-select-ip-reports", studyid, pageNumber, pageSize, searchText],
      queryFn: () => reportsSummaryApiService.getSelectIpReports({
        studyid: studyid!,
        currentpage: pageNumber,
        pagesize: pageSize,
        searchtext: searchText ?? null,
      }),
    });


  return {
    SelectSubjectWiseQuery,
    SelectLedgerQuery,
    SelectIpReportsQuery,
  };
};
